import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  description: 'Your Cards will appear here.',
  addCard: 'Add Card',
})
